export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum StatusType {
  COMPLETED = "Completed",
  APPROVAL_IN_PROGRESS = "Approval In Progress",
  APPROVED = "Approved",
  APPROVE = "Approve",
  DENY = "Deny",
  REVOKE = "Revoke",
  DENIED = "Denied",
  REVOKED = "Revoked",
}
